import clock from "./clock";
import display from "./display";
import { Handler } from "./handler";
import scoreboard from "./scoreboard";
import { upperFirst } from "./util";

export class ClearAllPenalties extends Handler {
    private side: "Home" | "Guest";

    constructor(side: "home" | "guest") {
        super();

        this.side = upperFirst(side) as typeof this.side;
    }

    boot(): void {
        display.line1(`${this.side.toUpperCase()} PLYR/PEN`);
        display.line2("CLEAR ALL Y/N?");
    }

    onEnter(): void {
        scoreboard[`clear${this.side}Penalties`]();
        clock.popHandler();
    }

    onClear(): void {
        clock.popHandler();
    }
}
